module.exports = __webpack_public_path__ + "static/media/visa-checkout-blanco.a30cac68.svg";